import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad090a50&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad090a50')) {
      api.createRecord('ad090a50', component.options)
    } else {
      api.reload('ad090a50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ad090a50&", function () {
      api.rerender('ad090a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/autoAudit/index.vue"
export default component.exports